var React = require('react');

function Quality (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.8312 10.2852L5.71436 22.441M14.8312 10.2852L23.4416 22.441M14.8312 10.2852H32.5585M50.2858 10.2852L58.8962 22.441M50.2858 10.2852H32.5585M50.2858 10.2852L41.1689 22.441M58.8962 22.441L32.5585 54.8566M58.8962 22.441H41.1689M32.5585 54.8566L5.71436 22.441M32.5585 54.8566L41.1689 22.441M32.5585 54.8566L23.4416 22.441M5.71436 22.441H23.4416M23.4416 22.441L32.5585 10.2852M23.4416 22.441H41.1689M32.5585 10.2852L41.1689 22.441","stroke":"#068DAA","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Quality.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64","fill":"none"};

module.exports = Quality;

Quality.default = Quality;
